import {apply, select, takeEvery} from 'redux-saga/effects';
import service from '../../services/ocularis/ocularisService';

const gotoBrowseFrameSaga = function*(action, panesAreFetching) {
    const {pane, time} = action;
    if (panesAreFetching[pane]) return;
    panesAreFetching[pane] = true;

    try {
        const {token} = yield select(state => state.API);
        const res = yield apply(service, service.playback.goto, [{token, time, pane}]);
        const blob = yield res.blob();
        const objectURL = URL.createObjectURL(blob);
        const elem = document.getElementById(`thumbnail-${pane}`);
        elem.src = objectURL;
        elem.onload = () => {
            delete panesAreFetching[pane]
        }
    }
    catch(e) {
        delete panesAreFetching[pane]
    }

};

export default function* (action) {
    const panesAreFetching = [];
    yield takeEvery('gotoBrowseFrame', (action) => gotoBrowseFrameSaga(action, panesAreFetching))
}